// extracted by mini-css-extract-plugin
module.exports = {"totalRow":"DailyReportSummaryTablePendeltag_totalRow_1LowI"};